<template>
	<MStateBox :loading="investment_activity.loading" :empty="isEmpty">
		<RowCardInfo
			v-for="(item, index) in displayActivityList"
			:key="index"
			:item="item"
			:formatter="formatter"
			@click="viewInvestmentActivity(item)"
		/>
		<slot name="footer"></slot>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import RowCardInfo from '@rebuild/materials/shared/common/RowCardInfo.vue';
import { formatIrYear, dateFormat } from '@/utils/api';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useCurrentReactive } from '@rebuild/materials/shared/investment_activity/context';
import { useInvestmentActivityTabs } from './useInvestmentActivityTabs';
import i18n, { EN } from '@/assets/js/i18n';
import { useCommonData } from '@rebuild/hooks/useCommonData';

const { isCardMTmpl } = useCommonData();

const { viewInvestmentActivity } = useCurrentReactive();
const { getAvailableTabs } = useInvestmentActivityTabs();
const isEn = computed(() => i18n.locale === EN);

const formatter = data => {
	return {
		imageUrl: formatActivityImage(data),
		date: formatActivityDate(data)
	};
};
const formatActivityImage = item => {
	const isResearch = item.businessTypes === 3;
	if (isResearch) return null;
	return item.logo43;
};
const formatActivityDate = item => {
	const isResearch = item.businessTypes === 3;
	if (isResearch) return dateFormat(new Date(Number(item.date)), 'yyyy-MM-dd');
	return formatIrYear(item.date);
};

const { investment_activity } = useModuleData();
const isEmpty = computed(() => {
	const { data, empty } = investment_activity;
	return empty || !data?.rows?.length;
});

const displayActivityList = computed(() => {
	const data = investment_activity?.data?.rows || [];
	// 展示最新的3条
	return data?.slice(0, 3);
});

const loadData = async (businessTypes = []) => {
	return investment_activity.refresh({
		pagestart: 0,
		pagenum: 20,
		businessTypes
	});
};

const BUSINESS_TYPES = {
	'research': 3,
	'roadshow': 8,
	'offline': 9
};

const refresh = async done => {
	if (isEn.value && !isCardMTmpl.value) {
		await loadData();
	} else {
		const options = await getAvailableTabs();
		if (options.length) {
			let allTab = options.find(v => v.value === 'investment_activity_all');
			let type = allTab ? [] : options.map(item => BUSINESS_TYPES[item.value]).filter(item => item !== undefined);
			await loadData(type);
		} else {
			investment_activity.loading = false;
		}
	}

	done && done();
};

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped></style>
